export default {
    title: "Integración de Email",
    subtitle: "Conecta tus cuentas de email para importar automáticamente documentos de los adjuntos",
    addAccount: "Añadir Cuenta de Email",

    // Empty state
    noAccounts: "No hay cuentas de email conectadas",
    noAccountsDescription: "Conecta una cuenta de email para que Eve importe automáticamente documentos de tu bandeja de entrada.",
    getStarted: "Comenzar",

    // Account list
    accountsList: {
        title: "Cuentas Conectadas",
        lastSync: "Última sincronización",
        neverSynced: "Nunca sincronizado",
        minutesAgo: "hace {{count}} min",
        hoursAgo: "hace {{count}} horas",
        syncNow: "Sincronizar",
        syncing: "Sincronizando...",
        configRequired: "Configura los ajustes de sincronización para empezar",
        syncStarted: "Proceso de sincronización iniciado con éxito",
        syncInProgress: "Sincronización en curso",
        syncingInfoTooltip: "Las acciones estarán disponibles de nuevo cuando termine la sincronización.",
        stopSync: "Detener sincronización",
    },

    // Status badges
    status: {
        active: "Conectado",
        inactive: "Inactivo",
        error: "Error",
        authentication_required: "Reconexión Requerida",
        syncing: "Sincronizando",
    },

    // Provider names
    providers: {
        gmail: "Gmail",
        outlook: "Outlook",
        imap_smtp: "IMAP/SMTP",
    },

    // Actions
    actions: {
        configure: "Configurar",
        reconnect: "Reconectar",
        remove: "Eliminar",
        cancel: "Cancelar",
        back: "Atrás",
        continue: "Continuar",
        connect: "Conectar Cuenta",
        test: "Probar Conexión",
        save: "Guardar Cambios",
        saving: "Guardando...",
        close: "Cerrar",
    },

    // Wizard
    wizard: {
        title: "Conectar Cuenta de Email",
        steps: {
            email: "Dirección de Email",
            connect: "Conexión",
            success: "Completado",
        },
    },

    // Step 1: Email Entry
    emailEntry: {
        title: "Introduce tu dirección de email",
        description: "Detectaremos automáticamente la mejor forma de conectar según tu proveedor.",
        emailLabel: "Dirección de Email",
        emailPlaceholder: "tu@empresa.com",
        emailRequired: "La dirección de email es obligatoria",
        emailInvalid: "Introduce una dirección de email válida",
        displayNameLabel: "Nombre para Mostrar (opcional)",
        displayNamePlaceholder: "ej. Email de Trabajo, Bandeja de Documentos",
        displayNameHint: "Un nombre amigable para identificar esta cuenta",
        providerDetected: "Proveedor detectado: {{provider}}",
    },

    // Step 2A: Gmail OAuth
    gmailOAuth: {
        title: "Conectar Gmail",
        description: "Inicia sesión con tu cuenta de Google para autorizar a Eve a leer tus emails.",
        secureAccess: "Acceso Seguro con Google",
        permissionsTitle: "Eve solicitará los siguientes permisos:",
        permissionRead: "Leer tus emails y adjuntos",
        permissionModify: "Marcar emails como leídos después de procesarlos",
        signInButton: "Iniciar sesión con Google",
        redirectNote: "Serás redirigido a la página de inicio de sesión de Google.",
    },

    // Step 2B: Outlook OAuth
    outlookOAuth: {
        title: "Conectar Outlook",
        description: "Inicia sesión con tu cuenta de Microsoft para autorizar a Eve a leer tus emails.",
        secureAccess: "Acceso Seguro con Microsoft",
        permissionsTitle: "Eve solicitará los siguientes permisos:",
        permissionRead: "Leer tus emails y adjuntos",
        permissionModify: "Marcar emails como leídos después de procesarlos",
        signInButton: "Iniciar sesión con Microsoft",
        redirectNote: "Serás redirigido a la página de inicio de sesión de Microsoft.",
    },

    // Step 2C: IMAP Configuration
    imapConfig: {
        title: "Configurar Servidor de Email",
        description: "Introduce la configuración de tu servidor de email para conectar la cuenta.",
        presetLabel: "Proveedor de Email",
        presetPlaceholder: "Selecciona tu proveedor de email...",
        customOption: "Configuración Manual / Otro",

        imapSection: "Correo Entrante (IMAP)",
        imapHost: "Servidor IMAP",
        imapHostPlaceholder: "imap.ejemplo.com",
        imapHostRequired: "El servidor IMAP es obligatorio",
        imapPort: "Puerto",
        imapUseSsl: "Usar SSL/TLS",

        smtpSection: "Correo Saliente (SMTP)",
        smtpHost: "Servidor SMTP",
        smtpHostPlaceholder: "smtp.ejemplo.com",
        smtpPort: "Puerto",
        smtpUseSsl: "Usar SSL/TLS",

        credentialsSection: "Credenciales",
        username: "Nombre de Usuario",
        usernamePlaceholder: "Normalmente tu dirección de email",
        password: "Contraseña / App Password",
        passwordPlaceholder: "Introduce tu contraseña",
        passwordRequired: "La contraseña es obligatoria",

        appPasswordHint: "Si tienes la autenticación de dos factores activada, necesitarás usar una App Password en lugar de tu contraseña normal.",
        appPasswordLink: "Aprende cómo crear una App Password",

        testConnection: "Probar Conexión",
        testing: "Probando conexión...",
        testSuccess: "¡Conexión exitosa!",
        testFailed: "Conexión fallida",
        testFailedMessage: "No se pudo conectar: {{error}}",

        connecting: "Conectando...",
    },

    // Step 3: Success
    success: {
        title: "¡Cuenta Conectada!",
        description: "Tu cuenta de email ha sido conectada exitosamente a Eve.",
        whatHappensNext: "¿Qué sucede ahora?",
        step1: "Eve monitoreará tu bandeja de entrada para nuevos emails con adjuntos",
        step2: "PDF y documentos adjuntos serán importados automáticamente",
        step3: "Encontrarás los documentos importados en la sección Documentos",
        viewAccounts: "Ver Cuentas Conectadas",
        addAnother: "Añadir Otra Cuenta",
    },

    // Remove confirmation
    removeConfirm: {
        title: "Eliminar Cuenta de Email",
        message: "¿Estás seguro de que quieres eliminar {{email}}? Eve dejará de importar documentos de esta cuenta.",
        confirm: "Eliminar Cuenta",
        cancel: "Cancelar",
    },

    // Stop sync confirmation
    stopSyncConfirm: {
        title: "¿Detener sincronización?",
        message: "La sincronización en curso puede completarse en el servidor. La sincronización automática se desactivará y las acciones estarán disponibles de nuevo cuando termine el proceso.",
        cancel: "Cancelar",
        confirm: "Detener sincronización",
        stopping: "Deteniendo...",
    },

    // Configure modal
    configure: {
        title: "Configurar Cuenta",
        disclaimer: "Esta integración lee tus emails de forma silenciosa, sin cambiar el estado leído/no leído de los mensajes.",
        autoProcess: "Procesar adjuntos automáticamente",
        autoProcessHint: "Crear automáticamente documentos de los adjuntos de email",
        allowedDomains: "Dominios de remitente permitidos",
        allowedDomainsPlaceholder: "ej. proveedor.com, cliente.com",
        allowedDomainsHint: "Solo procesar emails de estos dominios. Dejar vacío para procesar todos.",
        foldersToWatch: "Carpetas a monitorear",
        foldersToWatchHint: "Selecciona qué carpetas de email monitorear para nuevos emails",
        selectFolders: "Seleccionar carpetas...",
        loadingFolders: "Cargando carpetas...",
        syncFromDate: "Sincronizar emails desde",
        syncFromDateHint: "Elige desde qué fecha importar emails. Se aplica en la primera sincronización.",
        syncFromNone: "Solo emails nuevos (predeterminado)",
        syncFromToday: "Desde hoy",
        syncFrom7days: "Últimos 7 días",
        syncFrom30days: "Últimos 30 días",
        syncFromCustom: "Fecha personalizada",
        syncFromDateAlreadySynced: "Esta cuenta ya ha sido sincronizada. La fecha solo se aplica a la primera sincronización.",
        syncConfirmTitle: "¿Sincronizar emails?",
        syncConfirmMessage: "¿Quieres proceder con la sincronización de emails ahora?",
        syncNow: "Sincronizar",
    },

    // Email view modal
    emailView: {
        title: "Detalles del Email",
        subtitle: "Ver contenido del email y adjuntos",
        from: "De",
        to: "Para",
        subject: "Asunto",
        date: "Fecha",
        body: "Contenido",
        attachments: "Adjuntos",
        noSubject: "(Sin asunto)",
        noContent: "No hay contenido disponible para este email.",
        errorLoading: "No se pudieron cargar los detalles del email.",
        processed: "Procesado",
    },

    // OAuth callbacks
    oauth: {
        success: "¡Cuenta de {{provider}} conectada exitosamente!",
        error: "No se pudo conectar la cuenta de {{provider}}",
        errorGeneric: "No se pudo conectar la cuenta de email. Inténtalo de nuevo.",
    },

    // Errors
    errors: {
        loadAccounts: "No se pudieron cargar las cuentas de email",
        createAccount: "No se pudo crear la cuenta de email",
        updateAccount: "No se pudo actualizar la cuenta de email",
        deleteAccount: "No se pudo eliminar la cuenta de email",
        testConnection: "No se pudo probar la conexión",
        oauthFailed: "Autenticación OAuth fallida",
        syncFailed: "Sincronización fallida",
    },
};
